/** Calendrier aléatoire sans doublon pour une campagne (même ordre pour D1–D4). */
export function pickSeasonCircuitCalendar(
  circuitIds: number[],
  meetingCount: number,
  random: () => number = Math.random
): number[] {
  if (circuitIds.length < meetingCount) {
    throw new Error(
      `Il faut au moins ${meetingCount} circuits distincts pour une saison de ${meetingCount} meetings.`
    );
  }
  const shuffled = [...circuitIds];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, meetingCount);
}

/** Valide un calendrier choisi par l’utilisateur avant création de saison. */
export function validateSeasonCircuitCalendar(
  calendar: number[],
  meetingCount: number,
  availableCircuitIds: number[]
): void {
  if (calendar.length !== meetingCount) {
    throw new Error(
      `Le calendrier doit compter exactement ${meetingCount} circuit${meetingCount > 1 ? 's' : ''}.`
    );
  }
  const available = new Set(availableCircuitIds);
  const seen = new Set<number>();
  for (const id of calendar) {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error(`Identifiant de circuit invalide : ${id}`);
    }
    if (!available.has(id)) {
      throw new Error(`Circuit #${id} introuvable ou indisponible.`);
    }
    if (seen.has(id)) {
      throw new Error('Chaque circuit ne peut figurer qu’une fois dans le calendrier.');
    }
    seen.add(id);
  }
}

/** Parse le corps API `circuitCalendar` (optionnel). */
export function parseSeasonCircuitCalendarBody(raw: unknown): number[] | undefined {
  if (raw == null) return undefined;
  if (!Array.isArray(raw)) {
    throw new Error('circuitCalendar doit être un tableau d’identifiants de circuits.');
  }
  return raw.map((value, index) => {
    const id = Number(value);
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error(`circuitCalendar[${index}] : identifiant invalide.`);
    }
    return id;
  });
}
